import { render, staticRenderFns } from "./LockedGames.vue?vue&type=template&id=9979743e&"
import script from "./LockedGames.vue?vue&type=script&lang=js&"
export * from "./LockedGames.vue?vue&type=script&lang=js&"
import style0 from "./LockedGames.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports